import React, { Component } from 'react'
import _, { cloneDeep } from 'lodash'
// import { connect } from 'react-redux'
import {
  Form,
  Button,
  Input,
  AutoComplete,
  Icon,
  Popconfirm,
  Radio,
  Select,
  Spin,
  Tabs,
  Alert,
  Modal
} from 'antd'
import RichTextEditor from 'react-rte'
import ProposalSections from '../../../../components/ProposalSections'
import ProposalSectionsPreview from '../../../../components/templates/ProposalSectionsPreview'
import ProposalMilestonesPreview from '../../../../components/templates/ProposalMilestonesPreview'
import ProposalMilestones from '../../../../components/proposal/ProposalMilestones'
import {
  convertToOption,
  convertToTemplateOption,
  changeProposalItemValue,
  arrayMove,
  changeSectionItemsStructure,
  sanitizeProposalClonedItems,
  sanitizeProposalTemplateSection,
  sanitizeProposalTempltateMilestones
} from '../../../../util'
import config from '../../../../config'
import numeral from 'numeral'
import uuid from 'uuidv4'

const { API_BASE } = config

const FormItem = Form.Item
const { TextArea } = Input
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const Option = Select.Option
const TabPane = Tabs.TabPane

class LeadProposalView extends Component {
  constructor(props) {
    super(props)

    this.state = {
      chargedTemplate: false,
      templateOptions: convertToOption(this.props.templates),
      preview: true,
      milestonesDataStructure: [],
      currentRevisionNumberPrint: 1,
      dataStructure: []
    }
  }

  handleTemplateChange = templateId => {
    const { form, estimateList, action } = this.props

    const selectedItem = this.props.proposalTemplates.find(
      row => parseInt(row.id, 0) === parseInt(templateId, 0)
    )
    if (selectedItem) {
      let changeTemplate = false
      // change the proposal structure
      if (action !== 'add') {
        if (
          window.confirm(
            'Are you sure you want to change the proposal template this is based off of? By doing so you will lose all data currently on the screen.'
          )
        ) {
          console.log('change the proposal structure')
          changeTemplate = true
        }
      } else {
        console.log('mount the proposal structure')
        changeTemplate = true
      }

      // get the selected template grand total
      // replace this value on the selected proposal template ${grand_total} var
      const selectedEstimateId = form.getFieldsValue(['estimate_id'])
      const selectedEstimate = estimateList.find(
        estimate => parseInt(selectedEstimateId.estimate_id, 10) === parseInt(estimate.id, 10)
      )

      // replace grand total from overview
      const replacedOverview = selectedItem.overview.replace(
        // eslint-disable-next-line no-template-curly-in-string
        '${grand_total}',
        numeral(selectedEstimate.grand_total).format('$0,0.00')
      )

      form.setFieldsValue({
        proposal_template_id: selectedItem.id,
        description: selectedItem.description,
        overview: RichTextEditor.createValueFromString(replacedOverview, 'html')
      })

      if (changeTemplate) {
        this.props.loadTemplateData(templateId)
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { wrapUpProposal } = this.props

    // Sometimes the Sections might download sooner, other times it may be the Items.
    // So we perform the same action on both scenarios and make sure we have all
    // data before proceding.
    if (this.props.templateSections !== prevProps.templateSections) {
      this.processIncomingData('template', 'section')
    }
    if (this.props.templateItems !== prevProps.templateItems) {
      this.processIncomingData('template', 'item')
    }

    if (this.props.proposalSections !== prevProps.proposalSections) {
      this.processIncomingData('proposal', 'section')
    }
    if (this.props.proposalItems !== prevProps.proposalItems) {
      this.processIncomingData('proposal', 'item')
    }

    // check the create/edit action
    if (wrapUpProposal) {
      const form = this.props.form
      form.validateFields((err, values) => {
        if (err) {
          this.props.handleChangeWrapUpProposal()
          return
        }
        values.overview = values.overview.toString('html')

        // set estimate description (just for save from localstorage)
        if (Number.isInteger(parseInt(values.estimate_id, 10))) {
          const selectedEstimate = this.props.estimateList.find(
            estimate => estimate.id === parseInt(values.estimate_id, 10)
          )
          values.estimate_description = selectedEstimate.description
        } else {
          values.estimate_description = values.estimate_id
        }

        // set template name (just for save from localstorage)
        if (Number.isInteger(parseInt(values.proposal_template_id, 10))) {
          const selectedTemplate = this.props.proposalTemplates.find(
            proposalTemplate => proposalTemplate.id === parseInt(values.proposal_template_id, 10)
          )
          values.proposal_template_name = selectedTemplate.name
        } else {
          values.proposal_template_name = values.proposal_template_id
        }

        const proposal = {
          proposalSections: this.state.dataStructure,
          proposalMilestones: this.state.milestonesDataStructure,
          proposalData: values
        }
        this.props.handleWrapUpProposal(proposal)
      })
    }

    // update the current version for printing
    if (prevProps.loadingRevision !== this.props.loadingRevision) {
      const { revisions } = this.props
      if (revisions) {
        this.setState({
          currentRevisionNumberPrint: revisions[revisions.length - 1].currentRevisionNumber
        })
      }
    }
  }

  processIncomingData = source => {
    const { action } = this.props
    // This will grab the template sections and items coming from props and add them to the grid.
    let sections = []
    let items = []
    let milestones = []

    if (source === 'template') {
      if (this.props.templateSections && this.props.templateItems) {
        sections = this.props.templateSections
        items = this.props.templateItems
        milestones = this.props.proposalMilestonesTemplate
      }
    }
    if (source === 'proposal') {
      if (this.props.proposalSections && this.props.proposalItems) {
        sections = this.props.proposalSections
        items = this.props.proposalItems
        milestones = this.props.proposalMilestones
      }
    }

    if (sections.length > 0) {
      if (sections.length > 0 && items.length > 0) {
        let groupedItems = sections.map((section, index) => {
          let sectionItem = cloneDeep(section)
          sectionItem.items = _.filter(items, (item, index) => {
            return (
              item.proposal_section_template_id === section.id ||
              item.proposal_section_id === section.id
            )
          })

          if (source === 'template' || action === 'clone') {
            sanitizeProposalTemplateSection(sectionItem)
            sanitizeProposalTempltateMilestones(milestones)
          }

          return sectionItem
        })

        // sort by order
        const sortedGroupedItems = _.sortBy(groupedItems, section => {
          const sortedItems = _.sortBy(section.items, item => {
            return item.order
          })

          section.items = sortedItems

          return section.order
        })

        this.setState({
          chargedTemplate: true,
          dataStructure: sortedGroupedItems,
          milestonesDataStructure: milestones
        })
      }
    }
  }

  handleStatusChange = e => {
    const proposalStatus = e.target.value
    this.setState(() => ({
      proposalStatus
    }))
  }

  handleOverviewChange = value => {
    this.setState({ overview: value })
  }

  handleItemChange = (e, sectionIndex, itemId) => {
    const { value } = e.target
    const { dataStructure } = this.state
    const newitemsValue = changeProposalItemValue(value, itemId, dataStructure[sectionIndex].items)
    let tmpDataStructure = dataStructure
    tmpDataStructure[sectionIndex].items = newitemsValue
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  moveItemRight = (index, sectionIndex, item) => {
    if (index !== 0) {
      const { dataStructure } = this.state
      const newSectionItemsStructure = changeSectionItemsStructure(
        'moveRight',
        dataStructure[sectionIndex].items,
        item
      )
      let tmpDataStructure = dataStructure
      tmpDataStructure[sectionIndex].items = newSectionItemsStructure
      this.setState({
        dataStructure: tmpDataStructure
      })
    }
  }

  moveItemLeft = (index, sectionIndex, item) => {
    const { dataStructure } = this.state
    const newSectionItemsStructure = changeSectionItemsStructure(
      'moveLeft',
      dataStructure[sectionIndex].items,
      item
    )
    let tmpDataStructure = dataStructure
    tmpDataStructure[sectionIndex].items = newSectionItemsStructure
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  moveItemUp = (index, sectionIndex, item) => {
    if (index !== 0) {
      const { dataStructure } = this.state
      const newSectionItemsStructure = changeSectionItemsStructure(
        'moveUp',
        dataStructure[sectionIndex].items,
        item
      )
      let tmpDataStructure = dataStructure
      tmpDataStructure[sectionIndex].items = newSectionItemsStructure
      this.setState({
        dataStructure: tmpDataStructure
      })
    }
  }

  moveItemDown = (index, sectionIndex, item) => {
    const { dataStructure } = this.state
    const newSectionItemsStructure = changeSectionItemsStructure(
      'moveDown',
      dataStructure[sectionIndex].items,
      item
    )
    let tmpDataStructure = dataStructure
    tmpDataStructure[sectionIndex].items = newSectionItemsStructure
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  handleAddItem = sectionIndex => {
    const { dataStructure } = this.state
    let tmpDataStructure = dataStructure

    const newItem = {
      tmpId: uuid()
    }

    if (tmpDataStructure[sectionIndex].items) {
      tmpDataStructure[sectionIndex].items.push(newItem)
    } else {
      tmpDataStructure[sectionIndex].items = [newItem]
    }

    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  findItem = (item, data) => {
    if (data && data.length > 0) {
      let itemFound = data.find(i => i.id === item.id)
      if (itemFound) {
        return itemFound
      } else {
        let itemsWithSubItems = data.filter(i => i.items && i.items.length > 0)
        var newData = []
        itemsWithSubItems.forEach(el => {
          newData = newData.concat(el.items)
        })
        return this.findItem(item, newData)
      }
    }
  }

  handleDeleteItem = (index, sectionIndex, item) => {
    const { dataStructure } = this.state
    let tmpDataStructure = cloneDeep(dataStructure)
    const items = tmpDataStructure[sectionIndex].items
    const itemToModify = this.findItem(item, items)
    itemToModify.markedForDeletion = true
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  handleMoveSectionUp = sectionIndex => {
    if (sectionIndex !== 0) {
      const { dataStructure } = this.state
      let tmpDataStructure = dataStructure
      arrayMove(tmpDataStructure, sectionIndex, sectionIndex - 1)
      this.setState({
        dataStructure: tmpDataStructure
      })
    }
  }

  handleMoveSectionDown = sectionIndex => {
    const { dataStructure } = this.state
    if (sectionIndex + 1 !== dataStructure.length) {
      let tmpDataStructure = dataStructure
      arrayMove(tmpDataStructure, sectionIndex, sectionIndex + 1)
      this.setState({
        dataStructure: tmpDataStructure
      })
    }
  }

  handleDeleteSection = sectionIndex => {
    const { dataStructure } = this.state
    let tmpDataStructure = cloneDeep(dataStructure)
    tmpDataStructure[sectionIndex].markedForDeletion = true
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  handleAddSection = () => {
    const { dataStructure } = this.state
    let tmpDataStructure = dataStructure ? dataStructure : []
    tmpDataStructure.push({
      name: `New Section - ${tmpDataStructure.length + 1}`,
      tmpId: uuid()
    })
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  handleChangeSectionName = (sectionIndex, value) => {
    const { dataStructure } = this.state
    let tmpDataStructure = dataStructure
    tmpDataStructure[sectionIndex].name = value
    this.setState({
      dataStructure: tmpDataStructure
    })
  }

  handleDuplicateSection = () => {
    const { dataStructure, sectionName, modalSectionDuplicateIndex } = this.state

    let newDataStructure = cloneDeep(dataStructure)

    const clonedItems = cloneDeep(dataStructure[modalSectionDuplicateIndex].items)

    sanitizeProposalClonedItems(clonedItems)

    let duplicatedSection = {
      name: sectionName,
      tmpId: uuid(),
      items: clonedItems
    }
    newDataStructure.push(duplicatedSection)

    this.setState({
      dataStructure: newDataStructure,
      modalSectionNameVisible: false
    })
  }

  handleCancelSectionNameModal = () => {
    this.setState({
      modalSectionNameVisible: false
    })
  }

  handleOpenDuplicateSectionModal = index => {
    const { dataStructure } = this.state
    this.setState({
      sectionName: dataStructure[index].name,
      modalSectionNameVisible: true,
      modalSectionDuplicateIndex: index
    })
  }

  handleRevisionChange = revisionNumber => {
    const { form, revisions } = this.props
    const htmlFields = ['overview']

    const revision = revisions[revisionNumber]

    // set revision for printing
    this.setState({
      currentRevisionNumberPrint: revision.currentRevisionNumber
    })

    let changes = {}
    _.forEach(revision, (fieldValue, fieldName) => {
      if (fieldName === 'sections') {
        this.setState(prevState => {
          return { ...prevState, dataStructure: fieldValue }
        })
      }
      if (fieldName === 'milestones') {
        this.setState(prevState => {
          return { ...prevState, milestonesDataStructure: fieldValue }
        })
      }
      if (!_.isNil(form.getFieldsValue()[fieldName])) {
        if (htmlFields.includes(fieldName)) {
          changes[fieldName] = RichTextEditor.createValueFromString(fieldValue.toString(), 'html')
        } else {
          changes[fieldName] = fieldValue.toString()
        }
      }
    })

    form.setFieldsValue(changes)
  }

  togglePreview = () => {
    this.setState({
      preview: !this.state.preview
    })
  }

  /* Schedules/Milestones actions */
  handleAddMilestone = () => {
    const { milestonesDataStructure } = this.state
    const newMilestone = milestonesDataStructure ? milestonesDataStructure : []
    newMilestone.push({ description: '' })
    this.setState({
      milestonesDataStructure: newMilestone
    })
  }

  handleMilestoneChange = (value, index) => {
    let newMilestonesDataStructure = this.state.milestonesDataStructure
    newMilestonesDataStructure[index].description = value
    this.setState({
      milestonesDataStructure: newMilestonesDataStructure
    })
  }

  moveMilestoneUp = index => {
    const newMilestonesDataStructure = arrayMove(
      this.state.milestonesDataStructure,
      index,
      index - 1
    )
    this.setState({
      milestonesDataStructure: newMilestonesDataStructure
    })
  }

  moveMilestoneDown = index => {
    const newMilestonesDataStructure = arrayMove(
      this.state.milestonesDataStructure,
      index,
      index + 1
    )
    this.setState({
      milestonesDataStructure: newMilestonesDataStructure
    })
  }

  handleDeleteMilestone = index => {
    const { milestonesDataStructure } = this.state
    let tmpMilestonesDataStructure = [...milestonesDataStructure]
    tmpMilestonesDataStructure[index].markedForDeletion = true
    this.setState({
      milestonesDataStructure: tmpMilestonesDataStructure
    })
  }

  render() {
    const {
      estimateList,
      proposalTemplates,
      contentData,
      revisions,
      loadingRevision,
      action
    } = this.props
    const { getFieldDecorator } = this.props.form
    const { preview, currentRevisionNumberPrint } = this.state
    return (
      <div>
        {action === 'clone' && (
          <Alert message="ATTENTION! You are about to clone a Proposal" type="warning" showIcon />
        )}
        <Form>
          {contentData && (
            <div>
              <div className="row">
                <div className="col-10">
                  <h2 className="marginBottom0">Proposal #{this.props.contentData.id}</h2>
                </div>
                <div className="col-2 text-right">
                  {loadingRevision ? (
                    <Spin size="small" />
                  ) : (
                    <a
                      href={`${API_BASE}/api/lead/proposals/${
                        this.props.contentData.id
                      }/print?revision=${currentRevisionNumberPrint}`}
                      target="_blank"
                    >
                      <Button icon="printer">Print Proposal</Button>
                    </a>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-12" />
              </div>
              <div className="row">
                <div className="col-md-12">
                  <FormItem label="Status">
                    {getFieldDecorator('status', {
                      initialValue: contentData ? contentData.status : null
                    })(
                      <RadioGroup>
                        <RadioButton value="Sent">Sent</RadioButton>
                        <RadioButton value="Received">Received</RadioButton>
                        <RadioButton value="Signed">Signed</RadioButton>
                      </RadioGroup>
                    )}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <FormItem label="Revision">
                    {loadingRevision ? (
                      <Spin size="small" />
                    ) : (
                      <Select
                        defaultValue={
                          revisions && revisions.length > 0
                            ? revisions[revisions.length - 1].currentRevisionNumber
                            : null
                        }
                        onChange={this.handleRevisionChange}
                      >
                        {revisions &&
                          revisions.map(revision => (
                            <Option
                              key={revision.currentRevisionNumber}
                              value={revision.currentRevisionNumber - 1} // revision index
                            >
                              {revision.currentRevisionNumber}
                            </Option>
                          ))}
                      </Select>
                    )}
                  </FormItem>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Estimate">
                {getFieldDecorator('estimate_id', {
                  initialValue: contentData
                    ? `${contentData.estimate_id} - ${contentData.estimate_description}`
                    : null,
                  rules: [
                    {
                      required: true,
                      message: 'Please select an Estimate'
                    }
                  ]
                })(
                  <AutoComplete
                    dataSource={convertToTemplateOption(estimateList)}
                    filterOption={(inputValue, option) =>
                      option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    style={{ width: 400 }}
                  >
                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                  </AutoComplete>
                )}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Template">
                {getFieldDecorator('proposal_template_id', {
                  initialValue: contentData ? contentData.proposal_template_name : null,
                  rules: [
                    {
                      required: true,
                      message: 'Please select a Template'
                    }
                  ]
                })(
                  <AutoComplete
                    dataSource={convertToOption(proposalTemplates)}
                    filterOption={(inputValue, option) =>
                      option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    style={{ width: 400 }}
                    onSelect={templateId => this.handleTemplateChange(templateId)}
                  >
                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                  </AutoComplete>
                )}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  initialValue: contentData ? contentData.description : null
                })(<TextArea placeholder="Type in description..." rows={4} />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Overview">
                {getFieldDecorator('overview', {
                  initialValue: contentData
                    ? RichTextEditor.createValueFromString(contentData.overview, 'html')
                    : RichTextEditor.createValueFromString('', 'html')
                })(<RichTextEditor onChange={this.handleOverviewChange} />)}
              </FormItem>
            </div>
          </div>
        </Form>
        <div className="row">
          <div className="col-12">
            <Button icon={preview ? 'edit' : 'bars'} onClick={() => this.togglePreview()}>
              {preview ? 'Edit Specifications and Time Schedule' : 'Back to Preview'}
            </Button>
          </div>
        </div>
        {preview && (
          <div className="row mt-3">
            <div className="col-12">
              <h4>SPECIFICATIONS:</h4>
              <ProposalSectionsPreview dataStructure={this.state.dataStructure} />
              <h4>TIME SCHEDULE:</h4>
              <ProposalMilestonesPreview
                milestonesDataStructure={
                  this.state.milestonesDataStructure
                    ? this.state.milestonesDataStructure
                    : this.props.milestonesDataStructure
                }
              />
            </div>
          </div>
        )}
        {!preview && (
          <Tabs defaultActiveKey="1">
            <TabPane tab="Specifications" key="1">
              <ProposalSections
                dataStructure={this.state.dataStructure}
                handleAddItem={this.handleAddItem}
                handleDeleteItem={this.handleDeleteItem}
                handleItemChange={this.handleItemChange}
                moveItemRight={this.moveItemRight}
                moveItemLeft={this.moveItemLeft}
                moveItemUp={this.moveItemUp}
                moveItemDown={this.moveItemDown}
                handleDuplicateSection={this.handleOpenDuplicateSectionModal}
                handleMoveSectionUp={this.handleMoveSectionUp}
                handleMoveSectionDown={this.handleMoveSectionDown}
                handleDeleteSection={this.handleDeleteSection}
                handleAddSection={this.handleAddSection}
                handleChangeSectionName={this.handleChangeSectionName}
              />
            </TabPane>
            <TabPane tab="Time Schedule" key="2">
              <ProposalMilestones
                milestonesDataStructure={this.state.milestonesDataStructure}
                handleAddMilestone={this.handleAddMilestone}
                handleMilestoneChange={this.handleMilestoneChange}
                moveMilestoneUp={this.moveMilestoneUp}
                moveMilestoneDown={this.moveMilestoneDown}
                handleDeleteMilestone={this.handleDeleteMilestone}
              />
            </TabPane>
          </Tabs>
        )}

        <Popconfirm
          title="Are you sure you want to delete this record?"
          onConfirm={this.props.handleDeleteProposal}
          onCancel={this.cancelDelete}
          okText="Yes"
          cancelText="No"
        >
          {contentData && <Button type="danger" icon="delete" />}
        </Popconfirm>
        <Modal
          visible={this.state.modalSectionNameVisible}
          title={'Clone Section'}
          onCancel={this.handleCancelSectionNameModal}
          onOk={this.handleDuplicateSection}
          width="40%"
          maskClosable={false}
        >
          <div className="jobDetailsHeader">Section Name</div>
          <Input
            value={this.state.sectionName}
            onChange={e => this.setState({ sectionName: e.target.value })}
          />
        </Modal>
      </div>
    )
  }
}

export default Form.create()(LeadProposalView)



// WEBPACK FOOTER //
// ./src/pages/lead/components/proposals/LeadProposalView.js